import React from 'react';

const error = (meta) => {
  return meta.error && meta.touched && <span className="error" style={{display: 'block'}}>{meta.error}</span>;
};

export default error;